<template>
<div class="container" style="padding-top: 5.5rem; background: #f4c41e; border-radius: 0 0 30px 30px" :class="{bgColor:!right}">
	<div class="header-tabbar" :class="orderNum > 0 ? 'orderTop': 'originTop'">
		<div class="headerTitle" :class="orderNum > 0 ? '': 'top0'">
			<div style="font-weight: bold;">{{ locationName.district }}</div>
			<div class="road">{{ locationName.road }}</div>
		</div>
		<!-- <div style="position: absolute; width: 2.5rem; right: 0.7rem;" :style="[orderNum > 0 ? {'top': '6.8rem'} : {'top': '2.8rem'}]">
			<img src="@/assets/image/member/service.png" style="width: 100%">
		</div> -->
		<div class="middle">
			<div class="tabbar">
				<div class="tabbar-item" :class="{active:right}" @click="changeTab(1)">
					{{ $t('menu.errand_buy') }}
				</div>
				<div class="tabbar-item" :class="{active:!right}" @click="changeTab(0)">
					{{ $t('menu.errand_send') }}
				</div>
				<!-- <div class="tabbar-indicator" :class="{right:right}"></div> -->
			</div>
		</div>
		<!-- <div class="right">
			<i class="iconfont" @click="popupVisible=true">&#xe6dc;</i>
		</div> -->
	</div>
	<!-- <mt-popup v-model="popupVisible" position="right" class="common-popup-wrapper">
		<div class="user-info"><i class="iconfont">&#xe715;</i>{{user.member_name}}<span class="link" @click="$router.push({name:'MemberIndex'})">用户中心</span></div>
		<div class="main-content">
			<div @click="$router.push({name:'MemberFeedback'})">
				<flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">意见反馈</span></flex-line>
			</div>
			<a :href="'tel:'+config.site_phone">
				<flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">联系客服</span></flex-line>
			</a>
		</div>

		<div class="btn-wrapper">
			<div class="item" @click="$router.push({name:'HomeIndex'})">
				<i class="iconfont">&#xe703;</i>
				<p>点外卖</p>
			</div>
			<div class="item" @click="$router.push({name:'MemberO2oErrandOrderList'})">
				<i class="iconfont">&#xe6de;</i>
				<p>订单</p>
			</div>
		</div>
	</mt-popup> -->
</div>
</template>

<script>
import { Indicator, MessageBox, Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import flexLine from '../../flexLine'
export default {
	name: 'O2oErrandHead',
	data () {
		return {
			popupVisible:false,
			right:this.flag
		}
	},
	props: {
		flag:{},
	},
	components: {
		flexLine
	},
	computed: {
		...mapState({
			member_point: state => state.member.point,
			user: state => state.member.info,
			config: state => state.config.config,
			orderNum: (state) => state.member.orderNum,
		}),
		locationName: function () {
			let ret = {
				district: '',
				road: this.$t('map.selectorDefault')
			}
			if (this.member_point.address) {
				ret = this.utils.addressFormatter(this.member_point.address)
			}
			return ret
		},
	},
	methods: {
		changeTab(right){
			if(right){
				this.$router.push({name:'MemberO2oErrand'})
			}else{
				this.$router.push({name:'MemberO2oErrandSend'})
			}
		},
	}
}
</script>

<style scoped lang="scss">
.headerTitle {
	position: absolute;
	z-index: 3;
	background: rgba(179, 158, 115, 0.7);
	padding: 10px 30px;
	top: 4rem;
	color: white;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 50px;
	border-radius: 0 0 15px 15px;
	letter-spacing: 1px;
	width: 145px;
}
.headerTitle .road {
  font-size: .6rem;
  margin: 10px auto 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 30vw;
  overflow: hidden;
}
.top0 {
	top: 0;
}
.main-content{padding: 0 .6rem;}
.bgColor {
	border-radius: 0 0 30px 30px;
}
.header-tabbar{background:#f4c41e;width:100%;display:flex;justify-content: center;padding-bottom: 10px; border-radius: 0 0 30px 30px;
	.left{width:2rem;text-align: center;line-height:1.6rem;color:#000;}
	.left .left-button{background-color: transparent;border: 0;box-shadow: none;color: inherit;display: inline-block;padding: 0;font-size: inherit;}
	.middle{flex:1; display: flex; justify-content: center; align-items: center;
		.tabbar {
			z-index: 99;
			width:65vw;
			margin:0 auto;
			display: flex;
			line-height:1.6rem;
			position:relative;
			justify-content: space-between;
			.tabbar-item {
				flex:0 0 4.5rem;
				text-align: center;
				font-size:.8rem;
				color: white;
				padding: 4px 0px;
				// background-color: #DD2C35;
				// box-shadow: 0px 2px 0px 0px #B22433;
				border-radius: 40px;
				letter-spacing: 3px;
				&.active{
					color: white;
					background-color: #3D3D3D;
					// background-color: #B22433;
				}
			}
			.tabbar-indicator {
				width:2.7rem;
				display: block;
				position: absolute;
				left: 14%;
				margin-left:-.5rem;
				bottom: .8rem;
				background-image: linear-gradient(#512900, #9e5000);
				height: 0.4rem;
				transition: left .3s;
				border-radius: .5rem;
				z-index: -1;
				&.right{left:64%}
			}
		}
	}
	.right{width:2rem;text-align: center;line-height:2.6rem;color:#000;}
}
.common-popup-wrapper{width:70%;
	.user-info{text-align:center;padding:1.5rem 0;font-size:.7rem;line-height:1rem;
		i{color:#3c87fa;font-size:1rem;margin-right:.2rem;}
		.link{font-size:.55rem;color:#3c87fa;margin-left:.3rem;}
	}
	.menu-item{
		.left-icon{color:#3c87fa}
	}
	.btn-wrapper{position:absolute;bottom:0;width:100%;display:flex;
		.item{flex:1;text-align:center;padding-bottom:1rem;
			i{font-size:1rem;width:1.5rem;text-align:center;height:1.5rem;line-height:1.5rem;display:block;border-radius:50%;color:#3c87fa;border:1px solid #3c87fa;margin:.5rem auto;}
			p{font-size:.6rem;}
		}
	}
}
</style>
